export function sortAcs<T extends { sortOrder: number }>(acs: readonly T[]): T[] {
  return [...acs].sort((a, b) => a.sortOrder - b.sortOrder);
}
